import types from './types';

export const showBackToTopButton = () => ({
    type: types.SHOW_BACK_TO_TOP_BUTTON
});

export const hideBackToTopButton = () => ({
    type: types.HIDE_BACK_TO_TOP_BUTTON
});
